import * as angular from 'angular';

import { IUserModel, ComponentDefinition, UserGroups } from '../../models';

class RecipientsPickerController implements angular.IComponentController {

    readonly levels: number[];
    readonly roles: string[];
    readonly users: IUserModel[];
    readonly userGroups: UserGroups[];

    static $inject = [];

}

export const wtRecipientsPicker: ComponentDefinition = {
    componentId: 'wtRecipientsPicker',
    controller: RecipientsPickerController,
    template: require('./recipientsPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        levels: '<',
        roles: '<',
        users: '<',
        userGroups: '<'
    }
};
